import { Injectable } from "@angular/core";
import { DatasourceOfflineDao } from './datasource/datasource-offline.dao';
import { EnvVarUserOfflineDao } from './envvaruser/envvaruser-offline.dao';
import { ResponseWorkflowOfflineDao } from './response-workflow/response-workflow-offline.dao';
import { WorkflowOfflineDao } from './workflow/workflow-offline.dao';
import { LogEnvVarUserOfflineDao } from './log-envvaruser/log-envvaruser-offline.dao';

@Injectable()
export class UnitOfWorkOfflineDao {
    constructor(
        public datasourcesDao: DatasourceOfflineDao,
        public envVarUserDao: EnvVarUserOfflineDao,
        public workflowDao: WorkflowOfflineDao,
        public responseWorkflowDao: ResponseWorkflowOfflineDao,
        public logEnvVarUserOfflineDao: LogEnvVarUserOfflineDao,
    ) {}
}